<div class="icon" [ngStyle]=getStyle()></div>